import logo from './../../../assets/image/logo.jpg';
import blankProfile from './../../../assets/image/blankProfile.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleLeft, faChartBar } from "@fortawesome/free-regular-svg-icons";
import { useLogout } from '../../../services/auth-services/useLogout';
import { useAuth } from '../../../services/auth-services/authContext';
import { AuthContextState } from '../../../utils/types';
import * as Tabs from './tabs';
import React, { useEffect, useState } from 'react';
// import { API_BASE_URL } from '../../../config/config';
import pathConstant from '../../../utils/path.constant';
import { Link } from 'react-router-dom';
import { faRankingStar, faStar } from '@fortawesome/free-solid-svg-icons';

export function SideBar () {

    const { decodedJwtData } = useAuth() as AuthContextState;
    const [sideBars, setSideBars] = useState<React.JSX.Element[]>([]);
    const [privArray, setPrivArray] = useState<number[] | undefined>(decodedJwtData?.account_priv);
    // const profile_pic = `${API_BASE_URL}/img/${decodedJwtData?.profile_picture}`;
    useEffect(()=>{
        function assingSideBarTabs () {
           if(!privArray) return false;
           
           const sortedPrivArray = [...privArray].sort((a, b) => a - b);
           setPrivArray(sortedPrivArray);
           const assignSideBars : React.JSX.Element[] = [];

           let hasFullAccessPipeline = false;
           let pipelineTabSet = false;

           privArray.forEach((priv : number) => {
                switch (priv) {
                    case 1:
                        assignSideBars.push(<Tabs.ManageUsersTab />)
                        break;
                    case 2:
                        assignSideBars.push(<Tabs.ManageDepartmentTab />)
                        break;
                    case 3:
                        assignSideBars.push(<Tabs.ManageJDLTab />)
                        break;
                    case 4:
                        assignSideBars.push(<Tabs.AttendanceTab />)
                        break;
                    case 5:
                        assignSideBars.push(<Tabs.FormatCvTab />)
                        break;
                    case 6:
                        assignSideBars.push(<Tabs.RequirementsTab />)
                        break;
                    case 7:
                        assignSideBars.push(<Tabs.HrManagementTab />)
                        break;
                    case 8:
                        assignSideBars.push(<Tabs.LeaveEmpTab />)
                        break;
                    case 10:
                        assignSideBars.push(<Tabs.CstDashboard />)
                        break;
                    case 11:
                        hasFullAccessPipeline = true;
                        break;
                    case 12:
                        pipelineTabSet = true;
                        assignSideBars.push(<Tabs.CddPipeLine full_access={hasFullAccessPipeline} />)
                        break;
                    case 13:
                        assignSideBars.push(<Tabs.CstRevenueTarget />)
                        break;
                    case 15:
                        assignSideBars.push(<Tabs.CandidateProfileTab />)
                        break;
                    default:
                        break;
                }
                setSideBars(assignSideBars);
           });
           if(!pipelineTabSet && hasFullAccessPipeline){
                assignSideBars.push(<Tabs.CddPipeLine full_access={hasFullAccessPipeline} />);
           }
        }

        assingSideBarTabs ();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    return (
    <div className='sidebar-container'>
        <div className='logo-container'>
            <img src={logo} className='side-bar-logo' alt="VCC Link Logo" />
        </div>
        <div className='account-container'>
            <div>
                <img src={blankProfile} className='account-img' alt="userProfile" />
            </div>
            <div className='flex flex-col justify-center'>
                <h2 className='text-gray-100 text-sm'>{decodedJwtData?.fullname}</h2>
                <p className='text-xs text-gray-200'>{decodedJwtData?.email}</p>
            </div>
        </div>

        <div className='side-bar-tab-container'>
            <div className='relative py-2 mb-2'>
                <Link to={pathConstant.REVENUE_TRACKER_DASHBOARD} target='_blank' rel='noopener noreferrer'>
                    <div className='tab bg-orange-500'>
                        <FontAwesomeIcon icon={faRankingStar} />
                        <p>Revenue Dasboard</p>
                    </div>
                    <small className='absolute text-xs top-0 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs top-3 right-3 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs top-6 right-8 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs bottom-0 left-3 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs top-1 left-9 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs top-0 right-9 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                    <small className='absolute text-xs bottom-1 left-14 animate-pulse text-yellow-300'>
                        <FontAwesomeIcon icon={faStar} />
                    </small>
                </Link>
            </div>
            <Link to={pathConstant.DASHBOARD}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faChartBar} />
                    <p>Dashboard</p>
                </div>
            </Link>
            {sideBars}
        </div>

        <div className='absolute bottom-0 w-full left-0'>
            <button type="button" onClick={useLogout()} className='button button-danger'>
                Logout  <FontAwesomeIcon icon={faArrowAltCircleLeft} />
            </button>
        </div>
    </div>
    );
}